/**
 * Testo per il link alla scheda informativa della domanda.
 */
export const ProcedureLinkText = 'Vai alle Informazioni della domanda';
